import React from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  ATTACHMENTS_TITLE_TEXT,
  EMPTY_ATTACHMENT_TEXT,
} from "./attachmentPanel.constants";

const AttachmentSummary = ({ countText, hasAttachments }) => (
  <div className="flex min-w-0 items-center gap-3">
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-info-surface text-primary">
      <AttachFileIcon fontSize="small" />
    </span>
    <div className="min-w-0">
      <p className="truncate text-sm font-semibold text-text">
        {hasAttachments ? ATTACHMENTS_TITLE_TEXT : EMPTY_ATTACHMENT_TEXT}
      </p>
      {countText && <p className="text-xs text-text-muted">{countText}</p>}
    </div>
  </div>
);

export default AttachmentSummary;
